import Health from './health';
import Food from './food';
import Water from './water';
import Morale from './morale';
import Coins from './coins';
import Ammo from './ammo';
import Debug from 'debug';
const debug = Debug('party:resources:resources');

const ResourceTypes = {
  Health: 'Health',
  Food: 'Food',
  Water: 'Water',
  Coins: 'Coins',
  Ammo: 'Ammo',
  Morale: 'Morale',

  Infamy: 'Infamy',
  Luck: 'Luck',
  Horse: 'Horse',
  Bindle: 'Bindle'
  // Wood: 'Wood',
  // Metal: 'Metal',
  // Cloth: 'Cloth',
  // Medicine: 'Medicine',
  // Luxury: 'Luxury'
};

// TODO: separate resources, attributes and items
const Resources = () => {
  const health = Health();
  const food = Food();
  const coins = Coins();
  const ammo = Ammo();
  const water = Water();
  const morale = Morale();
  let onChange = () => {};

  const setCallbacks = callbackList => {
    onChange = (index, oldValue, newValue, context) => {
      callbackList.forEach(callback => callback(index, oldValue, newValue, context));
    };
  };

  const attribs = {
    health: {
      ...health,
      label: 'Health',
      index: ResourceTypes.Health
    },
    food: {
      ...food,
      index: ResourceTypes.Food
    },
    water: { ...water, index: ResourceTypes.Water },
    morale: { ...morale, index: ResourceTypes.Morale },
    coins: { ...coins, label: 'Coins', index: ResourceTypes.Coins },
    ammo: {
      ...ammo,
      index: ResourceTypes.Ammo
    },
    infamy: { value: 0, index: ResourceTypes.Infamy },
    luck: { value: 5, index: ResourceTypes.Luck }
  };
  const items = {
    bindle: {
      label: 'Bindle',
      value: true,
      capacity: 100,
      index: ResourceTypes.Bindle
    },
    horse: {
      label: 'Saddles',
      value: false,
      capacity: 1000,
      index: ResourceTypes.Horse
    }
  };

  const weight = {
    current: 0,
    max: items.bindle.capacity,
    overweight: false,
    label: items.bindle.label
  };

  const init = () => {
    attribs.health.value = 5;
    attribs.food.value = 0;
    attribs.water.value = 0;
    attribs.morale.value = 0;
    attribs.coins.value = 0;
    attribs.ammo.value = 0;
    weight.current = 0;
    weight.max = items.bindle.capacity;
    weight.overweight = false;
    weight.label = items.bindle.label;

    // init() assigns straight to .value rather than going through delta, so seed the high-water
    // mark by hand. A new run starts a new scale: without this the previous run's peak survives
    // into it and the opening five reads as a man already dying.
    attribs.health.peak = attribs.health.value;
  };

  const reset = () => {
    init();
    debug(attribs);
  };

  const delta = (resources, context) => {
    Object.keys(resources).map(res => {
      const resource = attribs[res] || items[res];
      const oldValue = resource.value;
      let newValue = oldValue;
      if (typeof resources[res] == 'boolean') {
        newValue = resources[res];
        if (resource.capacity) {
          // If it's a resource that can carry weight
          weight.max = resource.capacity;
          weight.label = resource.label;
        }
      } else {
        let amountToAdd = resources[res];
        if (resource.isCarried) {
          // If the resource is carried
          if (amountToAdd > weight.max - weight.current) {
            // If it's too heavy
            amountToAdd = weight.max - weight.current;
            weight.overweight = true;
          } else {
            weight.overweight = false;
          }
          weight.current = Math.round((weight.current + amountToAdd) * 10) / 10;
        }
        const updatedAmount = oldValue + amountToAdd;
        let boundedAmount = resource.max ? Math.min(resource.max, updatedAmount) : updatedAmount;
        boundedAmount = resource.min ? Math.max(resource.min, boundedAmount) : boundedAmount;
        const roundedValue = Math.round(boundedAmount * 10) / 10;
        newValue = Math.max(0, roundedValue);
      }

      resource.value = newValue;

      // The high-water mark, for anything scored against how far the player has come rather than
      // against a ceiling they may never reach. Health is the only one that asks for it — see
      // health.js for why its danger bands are a share of this and not of `max`. Raised before
      // onChange so every listener reads a value and a peak that agree.
      if (resource.trackPeak) resource.peak = Math.max(resource.peak || 0, newValue);

      onChange(resource.index, oldValue, newValue, context);

      return newValue;
    });
  };

  const isVisible = ({ resources }, resource) => resources.includes(resource.index);

  init();

  return {
    attribs,
    items,
    weight,
    isVisible,
    delta,
    reset,
    setCallbacks
  };
};

export { ResourceTypes };
export default Resources;
